import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Typography } from 'shared/ui'
import { AgentActionsList } from 'widgets/AgentActions'
import { type CategoryActionsStore } from 'pages/surveys/ui/SurveyView/ui/SuccessActions/store/categoryActionsStore'
import {
  SUCCESS_ACTION_ITEMS,
  SUCCESS_ACTIONS_CONFIG,
} from 'pages/surveys/ui/SurveyView/ui/SuccessActions/config'
import styles from './styles.module.scss'

type ICategoryActionsProps = {
  store: CategoryActionsStore
  label: string
  dotColor: 'green' | 'orange' | 'red'
}

export const CategoryActions = observer(({ store, label, dotColor }: ICategoryActionsProps) => {
  useEffect(() => {
    if (store.control.list.length > 0) store.resetSectionError()
  }, [store.control.list.length])

  return (
    <div className={styles.category}>
      <div className={styles.categoryLabel}>
        <span className={`${styles.dot} ${styles[`dot_${dotColor}`]}`} />
        <Typography variant={'body-rg-medium'} ariaLabel={label}>
          {label}
        </Typography>
      </div>
      <AgentActionsList
        control={store.control}
        errors={store.errors}
        actionItems={SUCCESS_ACTION_ITEMS}
        actionsConfig={SUCCESS_ACTIONS_CONFIG}
        addButtonText='Add action (optional)'
      />
    </div>
  )
})
